import React, { Component } from 'react';



const About=()=>{
    return(
<div className='ninetyPer'>
    <h1>THis is the About PAGE</h1>
    <p>This is About page para</p>
</div>
        
    )
}

export default About
